export default "__VITE_PUBLIC_ASSET__430d6bfb__"